import { useOpenModal, useConnectModal } from '@rainbow-modules/hooks';
import Button from 'components/Button';
import CopyToClipboardButton from 'components/CopyToClipboardButton';
import { SIP_USER_CREATED_MODAL } from '../../../../../../constants';
import {
    StyledModal,
    ModalContent,
    FieldRow,
    FieldLabel,
    FieldValueRow,
    FieldValue,
    PasswordHint,
    ModalFooter,
} from './styled';

const SipUserCreatedModal = () => {
    const [, closeModal] = useOpenModal(SIP_USER_CREATED_MODAL);
    const connectedProps = useConnectModal(SIP_USER_CREATED_MODAL);
    const {
        sipAddress,
        password,
        isOpen,
        ...modalProps
    } = connectedProps;

    const address = (sipAddress as string) ?? '';
    const username = address.split('@')[0] ?? '';
    const domain = address.split('@')[1] ?? '';

    return (
        <StyledModal
            {...modalProps}
            title="SIP User Created"
            isOpen={isOpen as boolean}
            onRequestClose={closeModal}
            borderRadius="semi-square"
            footer={(
                <ModalFooter>
                    <Button
                        label="Close"
                        variant="brand"
                        borderRadius="semi-square"
                        onClick={closeModal}
                    />
                </ModalFooter>
            )}
        >
            <ModalContent>
                <FieldRow>
                    <FieldLabel>Username</FieldLabel>
                    <FieldValueRow>
                        <FieldValue>{username}</FieldValue>
                        <CopyToClipboardButton
                            value={username}
                            mode="icon"
                            size="small"
                            variant="base"
                        />
                    </FieldValueRow>
                </FieldRow>
                <FieldRow>
                    <FieldLabel>Domain</FieldLabel>
                    <FieldValueRow>
                        <FieldValue>{domain}</FieldValue>
                        <CopyToClipboardButton
                            value={domain}
                            mode="icon"
                            size="small"
                            variant="base"
                        />
                    </FieldValueRow>
                </FieldRow>
                <FieldRow>
                    <FieldLabel>Password</FieldLabel>
                    <FieldValueRow>
                        <FieldValue>{password as string}</FieldValue>
                        <CopyToClipboardButton
                            value={(password as string) ?? ''}
                            mode="icon"
                            size="small"
                            variant="base"
                        />
                    </FieldValueRow>
                </FieldRow>
                <PasswordHint>
                    This password will not be shown again. Save it now.
                </PasswordHint>
            </ModalContent>
        </StyledModal>
    );
};

export default SipUserCreatedModal;
